var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrashBin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33398 1.66602L7.50065 2.49935H4.16732C3.66732 2.49935 3.33398 2.83268 3.33398 3.33268C3.33398 3.83268 3.66732 4.16602 4.16732 4.16602H5.83398H14.1673H15.834C16.334 4.16602 16.6673 3.83268 16.6673 3.33268C16.6673 2.83268 16.334 2.49935 15.834 2.49935H12.5007L11.6673 1.66602H8.33398ZM4.16732 5.83268V16.666C4.16732 17.5827 4.91732 18.3327 5.83398 18.3327H14.1673C15.084 18.3327 15.834 17.5827 15.834 16.666V5.83268H4.16732ZM7.50065 7.49935C8.00065 7.49935 8.33398 7.83268 8.33398 8.33268V15.8327C8.33398 16.3327 8.00065 16.666 7.50065 16.666C7.00065 16.666 6.66732 16.3327 6.66732 15.8327V8.33268C6.66732 7.83268 7.00065 7.49935 7.50065 7.49935ZM12.5007 7.49935C13.0007 7.49935 13.334 7.83268 13.334 8.33268V15.8327C13.334 16.3327 13.0007 16.666 12.5007 16.666C12.0007 16.666 11.6673 16.3327 11.6673 15.8327V8.33268C11.6673 7.83268 12.0007 7.49935 12.5007 7.49935Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashBin);
export default __webpack_public_path__ + "static/media/TrashBin.f15b409f5be63aea14c50ef6ff36e2e6.svg";
export { ForwardRef as ReactComponent };